import { ReactElement } from 'react'
import { Error } from '@mui/icons-material'
import { Box, CircularProgress, Typography } from '@mui/material'

interface Props {
  loading: boolean
  error?: Error | null
}

const SavingIndicator = ({ loading, error }: Props): ReactElement | null => {
  if (loading) {
    return (
      <Box
        sx={theme => ({
          backgroundColor: theme.palette.grey[100],
          padding: theme.spacing(0.75),
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
        })}
      >
        <Typography variant="caption">Wird gespeichert</Typography>
        <CircularProgress size={14} />
      </Box>
    )
  }

  if (error) {
    return (
      <Box
        sx={theme => ({
          backgroundColor: theme.palette.grey[100],
          padding: theme.spacing(0.75),
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
        })}
      >
        <Typography variant="caption">Ungespeicherte Änderungen</Typography>
        <Error fontSize="small" color="error" />
      </Box>
    )
  }

  return null
}

export default SavingIndicator
